/**
 * Signup page with header and footer.
 */

import React from 'react';
import { useSearchParams } from 'react-router-dom';
import PhoneSignup from '../../components/auth/PhoneSignup';
import { PublicHeader, PublicFooter } from '../../components/public';

const Signup = () => {
  const [searchParams] = useSearchParams();
  const transactionId = searchParams.get('transactionId');

  return (
    <div className="auth-page-layout">
      <PublicHeader />
      <main className="auth-page-main">
        <PhoneSignup transactionId={transactionId} />
      </main>
      <PublicFooter />
    </div>
  );
};

export default Signup;
